export type ProductListSortOption = 'recommended' | 'price-asc' | 'price-desc';

export const parseProductListSortOption = (raw: string | null | undefined): ProductListSortOption => {
    if (raw === 'price-asc' || raw === 'price-desc') {
        return raw;
    }
    return 'recommended';
};
